export const hourDropdownOptions = (label: string) => {
  return [72, 48, 24].map((dur) => ({
    id: `${dur}`,
    value: dur,
    label: `${dur} hrs ${label}`,
  }));
};
